// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ApiPagingRequestSchema from './api-paging-request-schema';

const schema = {
  $id: '/int32-lookup-request-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
      nullable: true,
    },
    key: {
      type: 'string',
      nullable: true,
    },
    searchCriteria: {
      type: 'string',
      nullable: true,
    },
    paging: {
      ...ApiPagingRequestSchema,
    },
  },
} as IJSONSchema;

export default schema;
